//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Bestline',
  props: {
    bestline: Array,
    boardSize: Number,
    winrate: Number,
  },
  data: function () {
    return {
      selectIndex: null,
    }
  },
  methods: {
    getPVResult(index) {
      return {
        position: this.$store.state.ai.lastThinkPosition,
        pv: this.bestline
          .slice(0, index + 1),
      }
    },
    mouseoverPV(index) {
      this.selectIndex = index
      this.$emit('pvPreview', this.getPVResult(index))
    },
    mouseleavePV() {
      this.selectIndex = null
      this.$emit('pvPreview', null)
    },
    dblclickPV(index) {
      this.$emit('pvSet', this.getPVResult(index))
    },
  },
  watch: {
    bestline: function (bestline) {
      if (this.selectIndex) {
        if (this.selectIndex >= bestline.length) {
          this.selectIndex = null
          this.$emit('pvPreview', null)
        } else {
          this.$emit('pvPreview', this.getPVResult(this.selectIndex))
        }
      }
    },
  },
}
